import styled, { keyframes } from "styled-components";

import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  /* align-items: center; */
  justify-content: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;


export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin-top: 40px;
  z-index: 1;

  border-radius: 10px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  > h1 {
    margin: 10px;
  }

  @media (max-width: 425px) {
    width: 98%;

    padding: 10px;
  }
`;

export const Card = styled.section`
  height: 500px;
  margin: 10px;
  padding: 10px;
  background-color: var(--white);
  margin-bottom: 30px;

  border-radius: 10px;
  box-shadow: 2px 2px 5px;
  border: 1px solid var(--gray);
  display: flex;
  flex-direction: column;

  > iframe {
    width: 100%;
    flex: 1;

    border: 1px solid black;
    margin-bottom: 30px;
  }

  > button {
    width: 50%;
    align-self: center;
  }
`;

